import api from '.'

export const root = {
  createTeam (data, success, fail) {
    api.authenticatedRequest('POST', '/root/teams', data, success, fail)
  },
  getTeams (success, fail) {
    api.authenticatedRequest('GET', '/root/teams', null, success, fail)
  },
  getTeam (id, success, fail) {
    api.authenticatedRequest('GET', `/root/teams/${id}`, null, success, fail)
  },
  updateTeam (id, data, success, fail) {
    api.authenticatedRequest('PUT', `/root/teams/${id}`, data, success, fail)
  },
  getUsers (success, fail) {
    api.authenticatedRequest('GET', '/root/users', null, success, fail)
  },
  getContacts (query, success, fail) {
    const queryString = query ? `?query=${query}` : ''
    api.authenticatedRequest('GET', `/root/comms/contacts${queryString}`, null, success, fail)
  },
  getMessages (contact, success, fail) {
    api.authenticatedRequest('GET', `/root/comms/contacts/${contact}/messages`, null, success, fail)
  },
  sendMessage (contact, data, success, fail) {
    api.authenticatedRequest('POST', `/root/comms/contacts/${contact}/messages`, data, success, fail)
  },
  runScheduledJob (job, success, fail) {
    api.authenticatedRequest('POST', `/root/scheduledJobs/${job}`, null, success, fail)
  }
}
